import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarWrapper from './styles/sidebar.style';
import ViewDetails from '../../../components/viewDetails/viewDetailspopover';
import { Scrollbars } from 'react-custom-scrollbars-2';
import moment from 'moment';
import { getSecondsInTextTime } from '../../../utils/getInititials';


class Sidebar extends Component {
	constructor(props) {
		super(props);
	}


	render() {

		const { therapists, changeCallStatus } = this.props;
		const { todayVisits, activeCallHistory } = therapists;
		let startButtonText = "start call";
		let webCall = true;
		activeCallHistory.forEach(activeCall => {
			if(activeCall.callStatus.toLowerCase() === "on call"){
				startButtonText = "merge call";
				if(activeCall.source === "mobile"){
					webCall = false;
				}
			}
		})
		return (
			<SidebarWrapper>
			<aside className="page-header">
			<nav>
				<a><img className="logo" src="/images/kure-logo.png" width="70" alt="kure logo" /></a>
				<h3>video room</h3>
			</nav>
			<Scrollbars>
			<div className="scrollable-content">
			<section className="patient-queue">
				<h1 className="section-title">waiting room</h1>
				{activeCallHistory && activeCallHistory.length > 0 ? (
					webCall ? <div className="patient-lists">
					<ul>
						{activeCallHistory.map(activeCall =>
							<li className={activeCall.callStatus.toLowerCase() === "on call" ? "active" : ""} key={activeCall.callId}>
							<div className="patient-cards">
								<div className="patient-detail">
									<h1>{activeCall.patient}</h1>
								{activeCall.callStatus.toLowerCase() === "on call" ?
									<h2>{""}</h2>:
									<h2>Waiting {getSecondsInTextTime(activeCall.waitingTime)}</h2>}
								</div>
								<div className="actions">
								{activeCall.callStatus.toLowerCase() === "on call" ?
									<button className="end-call kurebtn" onClick={() => changeCallStatus("End Call", activeCall.callId)}>end call</button>:

									<button className="start-call kurebtn" onClick={() => changeCallStatus("On Call", activeCall.callId)}>{startButtonText}</button>}
									<ViewDetails onCallStatus={activeCall.callStatus.toLowerCase() === "on call"}
												removeCall={() => changeCallStatus("End Call", activeCall.callId)}
												callDetails={activeCall} />

								</div>
							</div>
						</li>
						)}

					</ul>
					</div> : <h2 className="no-patient-heading">There is an ongoing call in your mobile app, please end the call to proceed here.</h2>
				) : <h2 className="no-patient-heading">No one has checked in yet</h2>
				}
			</section>
			<section className="provider-schedule">
			<h1 className="section-title">FROM YOUR SCHEDULE TODAY</h1>
			<div className="provider-schedule-lists">
				<ul>
					{todayVisits.map((visit, index) => {
					return <li key={index}>
						<div className="schedule-card">
							<h3>{visit.patientinfo.FirstName + " " + visit.patientinfo.LastName}</h3>
							<h2>DOB: {visit.patientinfo.DOB && (moment(visit.patientinfo.DOB).format("MM/DD/YYYY")+ ", " + moment().diff(visit.patientinfo.DOB, 'years'))} years old</h2>
							{visit.patientinfo.caregiverInfo && visit.patientinfo.caregiverInfo.caregiverName && <h1>caregiver</h1>}
							{visit.patientinfo.caregiverInfo && visit.patientinfo.caregiverInfo.caregiverName && <h3>{visit.patientinfo.caregiverInfo.caregiverName}</h3>}
							{visit.patientinfo.caregiverInfo && visit.patientinfo.caregiverInfo.caregiverRelationship && <h2 className="p-0">{visit.patientinfo.caregiverInfo.caregiverRelationship}</h2>}
							{visit.patientinfo.caregiverInfo && visit.patientinfo.caregiverInfo.caregiverMobileNumber && <h2>{visit.patientinfo.caregiverInfo.caregiverMobileNumber}</h2>}
							<h1>visit type</h1>
							<h2>{visit.Type}</h2>
							<h1>confirmation status</h1>
							<h2>{visit.Status}</h2>
						</div>
					</li>})}
				</ul>
			</div>
			</section>
			</div>
			</Scrollbars>
		</aside>
			</SidebarWrapper>
		  ) 
	}
}

export default connect(
	state => state
)(Sidebar);
